/**
 * Anti-Scraper Protection - Noise Removal Script
 * 
 * This script ensures all scraper noise is:
 * 1. Hidden immediately (backup for CSS)
 * 2. Removed from DOM after page load (complete cleanup)
 * 
 * Real users never see the noise.
 * Scrapers (without JS) see confusing fake data in HTML source.
 */

(function() {
  'use strict';

  /**
   * Hide and remove all scraper noise elements
   */
  function removeScraperNoise() {
    // Find all noise elements by multiple selectors
    var selectors = [
      '.scraper-noise-wrapper',
      '[data-scraper-noise]',
      '[class*="scraper-noise"]',
      '[id^="scraper-noise"]'
    ];
    
    var noiseElements = document.querySelectorAll(selectors.join(','));
    var removedCount = 0;
    
    noiseElements.forEach(function(el) {
      try {
        // First hide it completely
        el.style.cssText = 'display:none!important;visibility:hidden!important;opacity:0!important;';
        el.setAttribute('hidden', '');
        el.setAttribute('aria-hidden', 'true');
        
        // Then remove from DOM
        if (el.parentNode) {
          el.parentNode.removeChild(el);
          removedCount++;
        }
      } catch(e) {
        // Silent fail - element might already be removed
      }
    });
    
    // Log for debugging (only in development)
    if (removedCount > 0 && window.location.hostname === '127.0.0.1') {
      console.log('🛡️ Anti-scraper: Removed ' + removedCount + ' noise block(s)');
    }
  }

  /**
   * Initialize protection
   */
  function init() {
    // Immediate cleanup attempt
    removeScraperNoise();
    
    // Cleanup after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(removeScraperNoise, 100);
      });
    } else {
      // DOM already loaded
      setTimeout(removeScraperNoise, 100);
    }
    
    // Final cleanup after all resources load
    window.addEventListener('load', function() {
      setTimeout(removeScraperNoise, 300);
    });
  }

  // Run initialization
  init();
})();
